module.exports = "pegasus_template/assets/classic-twitter.png";